export const validateLoginForm = (username, password) => {
  let errors = {};

  if (!username.trim()) {
    errors.username = "Username/Email is required";
  }

  if (!password) {
    errors.password = "Password is required";
  } else if (password.length < 8) {
    errors.password = "Password must be at least 8 characters";
  } else if (!/[A-Z]/.test(password)) {
    errors.password = "Password must include at least one uppercase letter (A-Z)";
  } else if (!/[a-z]/.test(password)) {
    errors.password = "Password must include at least one lowercase letter (a-z)";
  } else if (!/[0-9]/.test(password)) {
    errors.password = "Password must include at least one number (0-9)";
  } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    errors.password = "Password must include at least one special character (@, #, $, etc.)";
  }

  return errors;
};
export const validateChangePasswordForm = (oldPassword, newPassword, newPasswordCheck) => {
  let errors = {};

  if (!oldPassword.trim()) {
    errors.oldPassword = "Old password is required";
  } else if (oldPassword.length < 8) {
    errors.oldPassword = "Old password must be at least 8 characters";
  } else if (!/[A-Z]/.test(oldPassword)) {
    errors.oldPassword = "Old password must include at least one uppercase letter (A-Z)";
  } else if (!/[a-z]/.test(oldPassword)) {
    errors.oldPassword = "Old password must include at least one lowercase letter (a-z)";
  } else if (!/[0-9]/.test(oldPassword)) {
    errors.oldPassword = "Old password must include at least one number (0-9)";
  } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(oldPassword)) {
    errors.oldPassword = "Old password must include at least one special character (@, #, $, etc.)";
  }

  if (!newPassword) {
    errors.newPassword = "New password is required";
  } else if (newPassword.length < 8) {
    errors.newPassword = "New passwordmust be at least 8 characters";
  } else if (!/[A-Z]/.test(newPassword)) {
    errors.newPassword = "New password must include at least one uppercase letter (A-Z)";
  } else if (!/[a-z]/.test(newPassword)) {
    errors.newPassword = "new Password must include at least one lowercase letter (a-z)";
  } else if (!/[0-9]/.test(newPassword)) {
    errors.newPassword = "New password must include at least one number (0-9)";
  } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(newPassword)) {
    errors.newPassword = "New password must include at least one special character (@, #, $, etc.)";
  }

  if (!newPasswordCheck) {
    errors.newPasswordCheck = "New password check is required";
  } else if (newPasswordCheck.length < 8) {
    errors.newPasswordCheck = "New password check  must be at least 8 characters";
  } else if (!/[A-Z]/.test(newPasswordCheck)) {
    errors.newPasswordCheck = "New password check  must include at least one uppercase letter (A-Z)";
  } else if (!/[a-z]/.test(newPasswordCheck)) {
    errors.newPasswordCheck = "New password check  must include at least one lowercase letter (a-z)";
  } else if (!/[0-9]/.test(newPasswordCheck)) {
    errors.newPasswordCheck = "New password check  must include at least one number (0-9)";
  } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(newPasswordCheck)) {
    errors.newPasswordCheck = "New password check  must include at least one special character (@, #, $, etc.)";
  } else if (newPassword !== newPasswordCheck) {
    errors.newPasswordCheck = "Passwords don't match";
  }
  return errors;
};


export const validateDepartmentForm = (departmentName) => {
  let errors = {};
  if (!departmentName.trim()) {
    errors.departmentName = "Department name is required";
  }
  else if (!/^[A-Za-z\s]+$/.test(departmentName)) {
    errors.departmentName = "Department name must contain only letters";
  }
  else if (departmentName.length < 2) {
    errors.departmentName = "Department name must be at least 2 characters";
  } else if (departmentName.length > 30) {
    errors.departmentName = "Department name must not exceed 30 characters";
  }
  return errors;
};
export const validateForStatus = (newStatus) => {
  let errors = {};
  if (!newStatus.trim()) {
    errors.newStatus = "Status is required";
  }

  return errors;
};
export const validateDepartmentEditForm = (departmentName) => {
  let errors = {};
  if (!departmentName.trim()) {
    errors.departmentName = "Department name is required";
  }
  else if (!/^[A-Za-z\s]+$/.test(departmentName)) {
    errors.departmentName = "Department name must contain only letters";
  }
  else if (departmentName.length < 2) {
    errors.departmentName = "Department name must be at least 2 characters";
  } else if (departmentName.length > 30) {
    errors.departmentName = "Department name must not exceed 30 characters";
  }
  return errors;
};


export const validateCopyNewRoleForm = (newRole) => {
  let errors = {};
  if (!newRole.trim()) {
    errors.newRole = "New role name is required";
  }
  else if (newRole.length < 4) {
    errors.newRole = "New role name must be at least 4 characters";
  }
  else if (newRole.length > 30) {
    errors.name = "New role name must not exceed 30 characters";
  }
  return errors;
};

export const validateOtHours = (otHours) => {
  let errors = {};
  const trimmed = String(otHours).trim();
  if (!trimmed) {
    errors.otHours = 'OT hours is required';
  } else if (!/^\d{1,3}$/.test(trimmed)) {
    errors.otHours = 'Please enter a number between 0 and 999';
  }
  return errors;
};



export const validateForExitEmployee = (exitDate, exitReason) => {
  let errors = {};

  if (!exitDate) {
    errors.exitDate = "Exit date is required";
  }
  if (!exitReason.trim()) {
    errors.exitReason = "Reason is required";
  } else if (exitReason.length < 4) {
    errors.exitReason = "Reason must be at least 4 characters";
  } else if (exitReason.length > 30) {
    errors.exitReason = "Reason must not exceed 30 characters";
  }
  return errors;
};

export const validateAddRoleForm = (name) => {
  let errors = {};
  if (!name.trim()) {
    errors.name = "Role name is required";
  }
  else if (name.length < 4) {
    errors.name = "Role name must be at least 4 characters";
  }
  else if (name.length > 30) {
    errors.name = "Role name must not exceed 30 characters";
  }
  return errors;
};
export const validateAddPermissionCodeForm = (code, name) => {
  let errors = {};
  if (!code.trim()) {
    errors.code = "Permission code is required";
  }
  // else if (code.length < 4) {
  //   errors.name = "Role name must be at least 4 characters";
  // }
  // else if (name.length > 30) {
  //   errors.name = "Role name must not exceed 30 characters";
  // }
  if (!name.trim()) {
    errors.name = "Description is required";
  }
  else if (name.length < 4) {
    errors.name = "Description must be at least 4 characters";
  }
  else if (name.length > 50) {
    errors.name = "Description must not exceed 50 characters";
  }
  return errors;
};


export const validateAddVendorForm = (name, email, phone, address, gst, status = '') => {
  let errors = {};
  if (!name.trim()) {
    errors.name = "Vendor name is required";
  } else if (name.length > 100) {
    errors.name = "Vendor name must not exceed 100 characters";
  }

  if (!email.trim()) {
    errors.email = "Email is required";
  } else if (email.length < 5) {
    errors.email = "Email must be at least 5 characters";
  } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
    errors.email = "Enter a valid email address";
  }

  if (!phone.trim()) {
    errors.phone = "Mobile number is required";
  } else if (!/^(?!00)\d{10}$/.test(phone)) {
    errors.phone = "Mobile number must be exactly 10 digits and cannot start with '00'";
  }

  if (!address.trim()) {
    errors.address = "Address is required";
  } else if (address.length < 5) {
    errors.address = "Address must be at least 5 characters";
  } else if (address.length > 200) {
    errors.address = "Address must not exceed 200 characters";
  }

  if (!gst.trim()) {
    errors.gst = "GST number is required";
  } else if (!/^[0-9A-Z]{15}$/.test(gst)) {
    errors.gst = "GST number must be 15 alphanumeric characters like 09AAACH7409R1ZZ";
  }

  if (!status) {
    errors.status = "Status is required";
  }

  return errors;
};

export const validateAddCustomerForm = (name, email, phone, address, gst, pan_no, status = '') => {
  let errors = {};
  if (!name.trim()) {
    errors.name = "Customer name is required";
  }
  // else if (name.length < 30) {
  //   errors.name = "Customer name must be at least 30 characters";
  // }
  else if (name.length > 100) {
    errors.name = "Customer name must not exceed 100 characters";
  }

  if (!email.trim()) {
    errors.email = "Email is required";
  } else if (email.length < 5) {
    errors.email = "Email must be at least 5 characters";
  } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
    errors.email = "Enter a valid email address";
  }
  if (!phone.trim()) {
    errors.phone = "Mobile number is required";
  } else if (!/^(?!00)\d{10}$/.test(phone)) {
    errors.phone = "Mobile number must be exactly 10 digits and cannot start with '00'";
  }
  if (!address.trim()) {
    errors.address = "Address is required";
  } else if (address.length < 5) {
    errors.address = "Address must be at least 5 characters";
  }
  else if (address.length > 200) {
    errors.address = "Address must not exceed 200 characters";
  }
  if (!gst.trim()) {
    errors.gst = "GST number is required";
  } else if (!/^[0-9A-Z]{15}$/.test(gst)) {
    errors.gst = "GST number must be 15 alphanumeric characters like 09AAACH7409R1ZZ";
  }
  const trimmedPan = pan_no.trim();

  if (trimmedPan) {
    if (!/^[A-Z]{5}\d{4}[A-Z]{1}$/.test(trimmedPan)) {
      errors.pan_no = "PAN number must be in format ABCDE1234F (10 characters)";
    } else {
      delete errors.pan_no;
    }
  } else {
    delete errors.pan_no;
  }

  if (!status.trim()) {
    errors.status = "Status is required";
  }
  return errors;
};


export const validateAddressForm = (formData) => {
  let errors = {};

  if (!formData.address.trim()) {
    errors.address = "Address is required";
  } else if (formData.address.length < 5) {
    errors.address = "Address must be at least 5 characters";
  } else if (formData.address.length > 200) {
    errors.address = "Address must not exceed 200 characters";
  }

  if (!formData.pincode.trim()) {
    errors.pincode = "Pin code is required";
  } else if (!/^\d{6}$/.test(formData.pincode)) {
    errors.pincode = "Pin code must be a 6-digit number";
  }

  if (!formData.state_code.trim()) {
    errors.state_code = "State code is required";
  } else if (!/^\d{2}$/.test(formData.state_code)) {
    errors.state_code = "State code must be a 2-digit number";
  }

  if (!formData.state) {
    console.log("formData", formData);
    errors.state = "State is required";
  }

  if (!formData.city) {
    errors.city = "City is required";
  }

  if (!formData.addressType) {
    errors.addressType = "Address type is required";
  }

  return errors;
};


export const validateCategoryForm = (name = "", status = "") => {
  let errors = {};
  if (!name.trim()) {
    errors.name = "Category name is required";
  }
  else if (!/^[A-Za-z\s]+$/.test(name)) {
    errors.name = "Category name must contain only letters";
  }
  else if (name.length < 2) {
    errors.name = "Category name must be at least 2 characters";
  } else if (name.length > 30) {
    errors.name = "Category name must not exceed 30 characters";
  }
  if (!status.trim()) {
    errors.status = "Status is required";
  }
  return errors;
};
export const validateExpenseHeaderForm = (selectedProjectId = "", reportid = "") => {
  let errors = {};

  if (!selectedProjectId.trim()) {
    errors.selectedProjectId = "Project is required";
  }
  return errors;
};


export const validateAdjustAmount = (
  adjustAmount = ''
) => {
  let errors = {};
  if (!adjustAmount) {
    errors.adjustAmount = "Adjust amount is required";
  }
  return errors;
};

export const validateAddRestDay = (

  description = '',
  restDate = null,
  selectedEmployees,

) => {
  let errors = {};

  if (!restDate) {
    errors.restDate = "Date is required";
  }
  if (!selectedEmployees || selectedEmployees.length === 0) {
    errors.selectedEmployees = "Please select at least one employee.";
  }
  if (!description.trim()) {
    errors.description = "Description is required";
  } else if (description.length < 5) {
    errors.description = "Description must be at least 5 characters";
  } else if (description.length > 200) {
    errors.description = "Description must not exceed 200 characters";
  } else {
    delete errors.description;
  }
  return errors;
};

export const validateEditExpenseHeaderForm = (

  categoryId = '',
  description = '',
  amount = '',
  ExpenseDate = null
) => {
  let errors = {};

  if (!categoryId) {
    errors.categoryId = "Category is required";
  }
  if (!description.trim()) {
    errors.description = "Description is required";
  } else if (description.length < 5) {
    errors.description = "Description must be at least 5 characters";
  } else if (description.length > 200) {
    errors.description = "Description must not exceed 200 characters";
  } else {
    delete errors.description;
  }
  if (!amount) {
    errors.amount = "Amount is required";
  }
  if (!ExpenseDate) {
    errors.ExpenseDate = "Expense  Date is required";
  }

  return errors;
};


export const validateProjectForm = (name = "", customerId = "", description = "", startDate = null, targetDate = null, endDate = null, status = "") => {
  let errors = {};
  if (!name.trim()) {
    errors.name = "Project name is required";
  }
  // else if (name.length < 30) {
  //   errors.name = "Project name must be at least 30 characters";
  // }
  else if (name.length > 100) {
    errors.name = "Project name must not exceed 100 characters";
  }

  if (!customerId) {
    errors.customerId = "Customer name is required";
  }
  if (!startDate) {
    errors.startDate = "Start date is required";
  }

  if (!targetDate) {
    errors.targetDate = "Target date is required";
  }

  // if (!endDate) {
  //   errors.endDate = "End date is required";
  // }

  if (startDate && targetDate && startDate > targetDate) {
    errors.targetDate = "Target date must be after start date";
  }

  if (endDate && startDate && endDate < startDate) {
    errors.endDate = "End date cannot be before start date";
  }

  if (endDate && targetDate && endDate < targetDate) {
    errors.endDate = "End date cannot be before target date";
  }
  if (description) {
    if (description.length < 5) {
      errors.description = "Description must be at least 5 characters";
    } else if (description.length > 200) {
      errors.description = "Description must not exceed 200 characters";
    } else {
      delete errors.description;
    }
  } else {
    delete errors.description;
  }

  if (!status.trim()) {
    errors.status = "Status is required";
  }
  return errors;
};

export const validateAdvancePaymentForm = (

  amount = '',
  empid = '',
  description = '',
  dateOfPayment = '',
  type = '',
  // year = '',
  // month = ''
) => {
  let errors = {};

  if (!type.trim()) {
    errors.type = " Type is required";
  }

  if (!amount) {
    errors.amount = "Amount is required";
  }
  if (!empid) {
    errors.empid = "Employee name is required";
  }

  if (!description) {
    errors.description = "Description is required";
  } else if (description.length < 3) {
    errors.description = "Description must be at least 3 characters long";
  } else if (description.length > 200) {
    errors.description = "Description must not exceed 200 characters";
  }

  if (!dateOfPayment) {
    errors.dateOfPayment = "Date Of Payment is required";
  }
  // if (!year) {
  //   errors.year = "Year is required";
  // }
  // if (!month) {
  //   errors.month = "Month is required";
  // }
  return errors;
};

export const validateFineForm = (

  amount = '',
  empid = '',
  reason = '',
  fineDate = '',
  // year = '',
  // month = ''
) => {
  let errors = {};

  if (!amount) {
    errors.amount = "Amount is required";
  }
  if (!empid) {
    errors.empid = "Employee name is required";
  }
  if (!reason) {
    errors.reason = "Reason is required";
  } else if (reason.length < 3) {
    errors.reason = "Reason must be at least 3 characters long";
  } else if (reason.length > 200) {
    errors.reason = "Reason must not exceed 200 characters";
  }


  if (!fineDate) {
    errors.fineDate = "Fine date is required";
  }
  // if (!year) {
  //   errors.year = "Year is required";
  // }
  // if (!month) {
  //   errors.month = "Month is required";
  // }
  return errors;
};

export const validateAssignProjectForm = (selectedProjectId = '', startDate = null,) => {
  let errors = {};

  if (!selectedProjectId.trim()) {
    errors.selectedProjectId = "Project is required";
  }
  if (!startDate) {
    errors.startDate = "Start Date is required";
  }
  return errors;
};

export const validateAddEmployeeForm = (
  firstname = "",
  lastname = "",
  dateOfBirth = null,
  gender = "",
  maritalStatus = "",
  fathername = "",
  idNumber = '',
  address = '',
  country = "",
  state = "",
  city = "",
  mobile = "",
  phone = "",
  email = "",
  bankName = "",
  accountName = "",
  accountNumber = "",
  iBan = "",
  departmentId = '',
  nomineeName = '',
  nomineeRelation = '',
  jobTitle = "null",
  startDate = null,
  // endDate = null,

  ecisNumber = '',
  pfNumber = '',
  panNumber = '',
  reportid = '',
  employmentType = 'null',
  salaryBasic = "",
  password = '',
  roleId = ''

) => {
  let errors = {};
  debugger;
  if (typeof firstname !== "string" || firstname.trim() === "") {
    errors.firstname = " First name is required";
  }
  else if (!/^[A-Za-z\s]+$/.test(firstname)) {
    errors.firstname = " First name must contain only letters";
  }
  else if (firstname.length < 2) {
    errors.firstname = " First name must be at least 2 characters";
  } else if (firstname.length > 30) {
    errors.firstname = " First name must not exceed 30 characters";
  }
  if (lastname.trim()) {
    if (!/^[A-Za-z\s]+$/.test(lastname)) {
      errors.lastname = "Last name must contain only letters";
    }
    else if (lastname.length < 2) {
      errors.lastname = "Last name must be at least 2 characters";
    }
    else if (lastname.length > 30) {
      errors.lastname = "Last name must not exceed 30 characters";
    }
  } else {
    delete errors.lastname;
  }


  if (!dateOfBirth || isNaN(new Date(dateOfBirth).getTime())) {
    errors.dateOfBirth = "Date of birth is required";
  } else {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    if (age < 18) {
      errors.dateOfBirth = "You must be at least 18 years old";
    }
  }
  if (!gender.trim()) {
    errors.gender = "Gender is required";
  }
  if (!maritalStatus.trim()) {
    errors.maritalStatus = "Marital status is required";
  }
  if (typeof fathername !== "string" || fathername.trim() === "") {
    errors.fathername = " Father name is required";
  }
  else if (!/^[A-Za-z\s]+$/.test(fathername)) {
    errors.fathername = " Father name must contain only letters";
  }
  else if (fathername.length < 2) {
    errors.fathername = " Father name must be at least 2 characters";
  } else if (fathername.length > 30) {
    errors.fathername = " Father name must not exceed 30 characters";
  }
  if (!idNumber.trim()) {
    errors.idNumber = "ID number is required";
  } else if (!/^\d+$/.test(idNumber)) {
    errors.idNumber = "ID number must contain only numbers";
  } else if (idNumber.length < 2) {
    errors.idNumber = "ID number must be at least 2 digits";
  } else if (idNumber.length > 15) {
    errors.idNumber = "ID number must not exceed 15 digits";
  }
  if (!address.trim()) {
    errors.address = "Address is required";
  } else if (address.length < 2) {
    errors.address = " Address must be at least 2 characters";
  } else if (address.length > 300) {
    errors.address = " Address must not exceed 300 characters";
  }

  if (!country.trim()) {
    errors.country = "Country is required";
  } else if (country.length < 2) {
    errors.country = " Country must be at least 2 characters";
  } else if (country.length > 50) {
    errors.country = " Country must not exceed 50 characters";
  }
  if (!state.trim()) {
    errors.state = "State is required";
  }
  if (!city.trim()) {
    errors.city = "City is required";
  } else if (city.length < 2) {
    errors.city = " City must be at least 2 characters";
  } else if (city.length > 50) {
    errors.city = " City must not exceed 50 characters";
  }
  if (!mobile.trim()) {
    errors.mobile = "Mobile number is required";
  } else if (!/^\d{10}$/.test(mobile)) {
    errors.mobile = "Mobile number must be exactly 10 digits";
  }

  if (phone.trim()) {
    const landlinePattern = /^\d{10,11}$/;

    if (!landlinePattern.test(phone)) {
      errors.phone = "Landline must be in the format- 07311234567";
    } else {
      delete errors.phone;
    }
  } else {
    delete errors.phone;
  }


  if (email.trim() && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
    errors.email = "Enter a valid email address.";
  } else {
    delete errors.email;
  }


  if (bankName.trim()) {
    if (!/^[A-Za-z\s]+$/.test(bankName)) {
      errors.bankName = "Bank name must contain only letters";
    } else if (bankName.length < 2) {
      errors.bankName = "Bank name must be at least 2 characters";
    } else if (bankName.length > 30) {
      errors.bankName = "Bank name must not exceed 30 characters";
    } else {
      delete errors.bankName;
    }
  } else {
    delete errors.bankName;
  }

  if (accountName.trim()) {
    if (!/^[A-Za-z\s]+$/.test(accountName)) {
      errors.accountName = "Account name must contain only letters";
    } else if (accountName.length < 2) {
      errors.accountName = "Account name must be at least 2 characters";
    } else if (accountName.length > 30) {
      errors.accountName = "Account name must not exceed 30 characters";
    } else {
      delete errors.accountName;
    }
  } else {
    delete errors.accountName;
  }

  if (accountNumber.trim()) {
    if (!/^\d+$/.test(accountNumber)) {
      errors.accountNumber = "Account number must contain only numbers";
    } else if (accountNumber.length < 6) {
      errors.accountNumber = "Account number must be at least 6 digits";
    } else if (accountNumber.length > 20) {
      errors.accountNumber = "Account number must not exceed 20 digits";
    } else {
      delete errors.accountNumber;
    }
  } else {
    delete errors.accountNumber;
  }

  if (iBan.trim()) {
    if (iBan.length > 20) {
      errors.iBan = "IFSC code must not exceed 20 digits";
    } else {
      delete errors.iBan;
    }
  } else {
    delete errors.iBan;
  }
  // latest code--start
  if (!departmentId.trim()) {
    errors.departmentId = "Department id is required";
  }

  if (!nomineeName.trim()) {
    errors.nomineeName = " Nominee name is required";
  }
  else if (!/^[A-Za-z\s]+$/.test(nomineeName)) {
    errors.nomineeName = " Nominee name must contain only letters";
  }
  else if (nomineeName.length < 2) {
    errors.nomineeName = " Nominee name must be at least 2 characters";
  } else if (nomineeName.length > 30) {
    errors.nomineeName = " Nominee name must not exceed 30 characters";
  }
  if (!nomineeRelation.trim()) {
    errors.nomineeRelation = " Nominee relation is required";
  }
  else if (!/^[A-Za-z\s]+$/.test(nomineeRelation)) {
    errors.nomineeRelation = " Nominee relation must contain only letters";
  }
  else if (nomineeRelation.length < 2) {
    errors.nomineeRelation = " Nominee relation must be at least 2 characters";
  } else if (nomineeRelation.length > 30) {
    errors.nomineeRelation = " Nominee relation must not exceed 30 characters";
  }

  if (!jobTitle.trim()) {
    errors.jobTitle = "Job title is required";
  }
  else if (!/^[A-Za-z\s]+$/.test(jobTitle)) {
    errors.jobTitle = " Job title must contain only letters";
  }
  else if (jobTitle.length < 2) {
    errors.jobTitle = " Job title must be at least 2 characters";
  } else if (jobTitle.length > 30) {
    errors.jobTitle = " Job title must not exceed 30 characters";
  }



  if (!startDate) {
    errors.startDate = "Start date is required";
  } else {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const selectedStartDate = new Date(startDate);
    selectedStartDate.setHours(0, 0, 0, 0);

    if (selectedStartDate < firstDayOfCurrentMonth) {
      errors.startDate = "Start date must be in the current month or in the future";
    } else {
      delete errors.startDate; // No errors, valid start date
    }
  }

  // if (aadharNumber.trim()) {
  //   // Check if there's a '+' or '-' in the input
  //   if (/[-+]/.test(aadharNumber)) {
  //     errors.aadharNumber = "Aadhar number cannot contain '+' or '-' signs.";
  //   } else if (!/^\d{12}$/.test(aadharNumber)) {
  //     errors.aadharNumber = "Aadhar number must be exactly 12 digits.";
  //   } else {
  //     delete errors.aadharNumber;
  //   }
  // } else {
  //   delete errors.aadharNumber;
  // }


  if (ecisNumber.trim()) {
    if (!/^\d{5,15}$/.test(ecisNumber)) {
      errors.ecisNumber = "ECIS number must contain only numbers (5-15 digits)";
    } else {
      delete errors.ecisNumber;
    }
  } else {
    delete errors.ecisNumber;
  }

  if (pfNumber && pfNumber.trim()) {
    if (!/^[A-Za-z0-9]{5,30}$/.test(pfNumber)) {
      errors.pfNumber = "PF number must be alphanumeric (5-30 characters)";
    } else {
      delete errors.pfNumber;
    }
  } else {
    delete errors.pfNumber;
  }


  const trimmedPan = (panNumber || "").trim().toUpperCase();

  if (trimmedPan.length > 0) {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
    if (!panRegex.test(trimmedPan)) {
      errors.panNumber = "PAN number must be in format ABCDE1234F";
    }
  }


  if (!reportid) {
    errors.reportid = "Report id is required";
  }

  if (!employmentType) {
    errors.employmentType = "Employment type is required";
  }

  if (salaryBasic === null || salaryBasic === undefined || salaryBasic === 0) {
    errors.salaryBasic = "Salary basic is required";
  }

  return errors;
};


export const validateEditEmployeeForm = (formData) => {
  const {
    user = {},
    userPersonalInfo = {},
    reportingUser = {},
    userFinancialInfo = {},
    employee = {},
  } = formData;

  let errors = {
    user: {},
    userPersonalInfo: {},
    userFinancialInfo: {},
    employee: {},
    reportingUser: {}
  };

  // User validation
  if (!user.fullName) {
    errors.user.fullName = "Full name is required";
  } else if (!/^[A-Za-z\s]+$/.test(user.fullName)) {
    errors.user.fullName = "Full name must contain only letters";
  } else if (user.fullName.length < 2) {
    errors.user.fullName = "Full name must be at least 2 characters";
  } else if (user.fullName.length > 30) {
    errors.user.fullName = "Full name must not exceed 30 characters";
  }

  if (!user.role) {
    errors.user.role = "Role is required";
  }

  if (!user.departmentId) {
    errors.user.departmentId = "Department ID is required";
  }
  // const isActive = user.active === true || user.active === 1;

  // if (isActive) {
  //   if (!user.password) {
  //     errors.user.password = "Password is required for active users";
  //   } else if (user.password.length < 6) {
  //     errors.user.password = "Password must be at least 6 characters";
  //   } else if (user.password.length > 20) {
  //     errors.user.password = "Password must not exceed 20 characters";
  //   }
  //   // Optional: Add password strength validation
  //   else if (!/(?=.*[A-Z])(?=.*[a-z])(?=.*\d)/.test(user.password)) {
  //     errors.user.password = "Password must contain at least one uppercase letter, one lowercase letter, and one number";
  //   }
  // }

  // User Personal Info Validation
  if (!userPersonalInfo.gender) {
    errors.userPersonalInfo.gender = "Gender is required";
  }
  if (!userPersonalInfo.maritalStatus) {
    errors.userPersonalInfo.maritalStatus = "Marital status is required";
  }
  if (!userPersonalInfo.fatherName) {
    errors.userPersonalInfo.fatherName = "Father name is required";
  } else if (!/^[A-Za-z\s]+$/.test(userPersonalInfo.fatherName)) {
    errors.userPersonalInfo.fatherName = "Father name must contain only letters";
  } else if (userPersonalInfo.fatherName.length < 2) {
    errors.userPersonalInfo.fatherName = "Father name must be at least 2 characters";
  } else if (userPersonalInfo.fatherName.length > 30) {
    errors.userPersonalInfo.fatherName = "Father name must not exceed 30 characters";
  }
  if (!userPersonalInfo.idNumber) {
    errors.userPersonalInfo.idNumber = "ID number is required";
  } else if (!/^\d+$/.test(userPersonalInfo.idNumber)) {
    errors.userPersonalInfo.idNumber = "ID number must contain only numbers";
  } else if (userPersonalInfo.idNumber.length < 2) {
    errors.userPersonalInfo.idNumber = "ID number must be at least 2 digits";
  } else if (userPersonalInfo.idNumber.length > 15) {
    errors.userPersonalInfo.idNumber = "ID number must not exceed 15 digits";
  }

  if (!userPersonalInfo.dateOfBirth || isNaN(new Date(userPersonalInfo.dateOfBirth).getTime())) {
    errors.userPersonalInfo.dateOfBirth = "Date of birth is required";
  } else {
    const today = new Date();
    const birthDate = new Date(userPersonalInfo.dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    if (age < 18) {
      errors.userPersonalInfo.dateOfBirth = "You must be at least 18 years old";
    }
  }
  if (!userPersonalInfo.address) {
    errors.userPersonalInfo.address = "Address is required";
  } else if (userPersonalInfo.address.length < 2) {
    errors.userPersonalInfo.address = "Address must be at least 2 characters";
  } else if (userPersonalInfo.address.length > 200) {
    errors.userPersonalInfo.address = "Address must not exceed 200 characters";
  }
  if (!userPersonalInfo.country) {
    errors.userPersonalInfo.country = "Country name is required";
  } else if (!/^[A-Za-z\s]+$/.test(userPersonalInfo.country)) {
    errors.userPersonalInfo.country = "Country name must contain only letters";
  } else if (userPersonalInfo.country.length < 2) {
    errors.userPersonalInfo.country = "Country name must be at least 2 characters";
  } else if (userPersonalInfo.country.length > 50) {
    errors.userPersonalInfo.country = "Country name must not exceed 50 characters";
  }
  if (!userPersonalInfo.city) {
    errors.userPersonalInfo.city = "City name is required";
  } else if (!/^[A-Za-z\s]+$/.test(userPersonalInfo.city)) {
    errors.userPersonalInfo.city = "City name must contain only letters";
  } else if (userPersonalInfo.city.length < 2) {
    errors.userPersonalInfo.city = "City name must be at least 2 characters";
  } else if (userPersonalInfo.city.length > 50) {
    errors.userPersonalInfo.city = "City name must not exceed 50 characters";
  }


  if (!userPersonalInfo.mobile) {
    errors.userPersonalInfo.mobile = "Mobile number is required";
  } else if (!/^[1-9][0-9]{9}$/.test(userPersonalInfo.mobile)) {
    errors.userPersonalInfo.mobile = "Mobile number must be exactly 10 digits and cannot start with 00";
  }


  if (userPersonalInfo.phone && !/^0\d{10}$/.test(userPersonalInfo.phone)) {
    errors.userPersonalInfo.phone = "Phone number must be in the format: 07311234567";
  }

  if (userPersonalInfo.emailAddress && !/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(userPersonalInfo.emailAddress)) {
    errors.userPersonalInfo.emailAddress = "Invalid email address format";
  }


  // User Financial Info Validation
  // Validate Bank Name (Optional)
  if (userFinancialInfo.bankName?.trim()) {
    if (!/^[A-Za-z\s]+$/.test(userFinancialInfo.bankName)) {
      errors.userFinancialInfo.bankName = "Bank name must contain only letters";
    } else if (userFinancialInfo.bankName.length < 2) {
      errors.userFinancialInfo.bankName = "Bank name must be at least 2 characters";
    } else if (userFinancialInfo.bankName.length > 30) {
      errors.userFinancialInfo.bankName = "Bank name must not exceed 30 characters";
    } else {
      delete errors.userFinancialInfo.bankName;
    }
  } else {
    delete errors.userFinancialInfo.bankName;
  }

  // Validate Account Name (Optional)
  if (userFinancialInfo.accountName?.trim()) {
    if (!/^[A-Za-z\s]+$/.test(userFinancialInfo.accountName)) {
      errors.userFinancialInfo.accountName = "Account name must contain only letters";
    } else if (userFinancialInfo.accountName.length < 2) {
      errors.userFinancialInfo.accountName = "Account name must be at least 2 characters";
    } else if (userFinancialInfo.accountName.length > 30) {
      errors.userFinancialInfo.accountName = "Account name must not exceed 30 characters";
    } else {
      delete errors.userFinancialInfo.accountName;
    }
  } else {
    delete errors.userFinancialInfo.accountName;
  }


  if (userFinancialInfo.accountNumber?.trim()) {
    if (!/^\d+$/.test(userFinancialInfo.accountNumber)) {
      errors.userFinancialInfo.accountNumber = "Account number must contain only numbers";
    } else if (userFinancialInfo.accountNumber.length < 6) {
      errors.userFinancialInfo.accountNumber = "Account number must be at least 6 digits";
    } else if (userFinancialInfo.accountNumber.length > 20) {
      errors.userFinancialInfo.accountNumber = "Account number must not exceed 20 digits";
    } else {
      delete errors.userFinancialInfo.accountNumber;
    }
  } else {
    delete errors.userFinancialInfo.accountNumber;
  }

  if (!userFinancialInfo.employmentType) {
    errors.userFinancialInfo.employmentType = "Employment type is required";
  }

  if (userFinancialInfo.iBan?.trim()) {
    if (userFinancialInfo.iBan.length > 20) {
      errors.userFinancialInfo.iBan = "IFSC code must not exceed 20 digits";
    } else {
      delete errors.userFinancialInfo.iBan;
    }
  } else {
    delete errors.userFinancialInfo.iBan;
  }


  // Employee Details Validation


  if (!employee.nominee_name) {
    errors.employee.nominee_name = "Nominee name is required";
  } else if (!/^[A-Za-z\s]+$/.test(employee.nominee_name)) {
    errors.employee.nominee_name = "Nominee name must contain only letters";
  } else if (employee.nominee_name.length < 2) {
    errors.employee.nominee_name = "Nominee name must be at least 2 characters";
  } else if (employee.nominee_name.length > 50) {
    errors.employee.nominee_name = "Nominee name must not exceed 50 characters";
  }


  if (!employee.nominee_relation) {
    errors.employee.nominee_relation = "Nominee relation name is required";
  } else if (!/^[A-Za-z\s]+$/.test(employee.nominee_relation)) {
    errors.employee.nominee_relation = "Nominee relation name must contain only letters";
  } else if (employee.nominee_relation.length < 2) {
    errors.employee.nominee_relation = "Nominee relation name must be at least 2 characters";
  } else if (employee.nominee_relation.length > 50) {
    errors.employee.nominee_relation = "Nominee relation name must not exceed 50 characters";
  }

  // if (employee.Aadhaar_number && employee.Aadhaar_number.trim()) {
  //   if (/[+\-]/.test(employee.Aadhaar_number)) {
  //     errors.employee.Aadhaar_number = "Aadhaar number cannot contain '+' or '-' signs.";
  //   } else if (!/^\d{12}$/.test(employee.Aadhaar_number)) {
  //     errors.employee.Aadhaar_number = "Aadhaar number must be exactly 12 digits.";
  //   } else {
  //     delete errors.employee.Aadhaar_number;
  //   }
  // } else {
  //   delete errors.employee.Aadhaar_number;
  // }


  // if (employee.Aadhaar_number && employee.Aadhaar_number.trim()) {
  //   if (!/^\d{12}$/.test(employee.Aadhaar_number)) {
  //     errors.employee.Aadhaar_number = "Aadhaar number must be exactly 12 digits";
  //   } else {
  //     delete errors.employee.Aadhaar_number;
  //   }
  // } else {
  //   delete errors.employee.Aadhaar_number;
  // }

  if (employee.pan_number && employee.pan_number.trim()) {
    if (!/^[A-Z]{5}\d{4}[A-Z]{1}$/.test(employee.pan_number)) {
      errors.employee.pan_number = "PAN number must be in format ABCDE1234F (10 characters)";
    } else {
      delete errors.employee.pan_number;
    }
  } else {
    delete errors.employee.pan_number;
  }

  if (employee.esic_number && employee.esic_number.trim()) {
    if (!/^\d{5,15}$/.test(employee.esic_number)) {
      errors.employee.esic_number = "ECIS number must contain only numbers (5-15 digits)";
    } else {
      delete errors.employee.esic_number;
    }
  } else {
    delete errors.employee.esic_number;
  }

  if (employee.pf_number && employee.pf_number.trim()) {
    if (!/^[A-Za-z0-9]{5,30}$/.test(employee.pf_number)) {
      errors.employee.pf_number = "PF number must be alphanumeric (5-30 characters)";
    } else {
      delete errors.employee.pf_number;
    }
  } else {
    delete errors.employee.pf_number;
  }
  if (!reportingUser.fullName) {
    errors.reportingUser.fullName = "Report to is required";
  }
  return errors;
};

export const validateJobForm = (jobTitle = "", selectedUser = "",
  selectedDepartment = "",
  startDate = null, endDate = null) => {
  let errors = {};
  if (!jobTitle.trim()) {
    errors.jobTitle = " Job title is required";
  }
  else if (!/^[A-Za-z\s]+$/.test(jobTitle)) {
    errors.jobTitle = " Job title must contain only letters";
  }
  else if (jobTitle.length < 2) {
    errors.jobTitle = " Job title must be at least 2 characters";
  } else if (jobTitle.length > 30) {
    errors.jobTitle = " Job title must not exceed 30 characters";
  }
  if (!selectedUser.trim()) {
    errors.selectedUser = "User name is required";
  }
  if (!selectedDepartment.trim()) {
    errors.selectedDepartment = "Department name is required";
  }
  if (!startDate) {
    errors.startDate = "Start date is required";
  }

  if (!endDate) {
    errors.endDate = "End date is required";
  }

  if (endDate && startDate && endDate < startDate) {
    errors.endDate = "End date cannot be before start date";
  }

  return errors;
};

export const validateJobEditForm = (jobTitle = "",
  startDate = null, endDate = null) => {
  let errors = {};
  if (!jobTitle.trim()) {
    errors.jobTitle = " Job title is required";
  }
  else if (!/^[A-Za-z\s]+$/.test(jobTitle)) {
    errors.jobTitle = " Job title must contain only letters";
  }
  else if (jobTitle.length < 2) {
    errors.jobTitle = " Job title must be at least 2 characters";
  } else if (jobTitle.length > 30) {
    errors.jobTitle = " Job title must not exceed 30 characters";
  }
  if (!startDate) {
    errors.startDate = "Start date is required";
  }

  if (!endDate) {
    errors.endDate = "End date is required";
  }

  if (endDate && startDate && endDate < startDate) {
    errors.endDate = "End date cannot be before start date";
  }

  return errors;
};

export const validateApplicationForm = (type = "",
  startDate = null, endDate = null) => {
  let errors = {};
  if (!type.trim()) {
    errors.type = " Type is required";
  }

  if (!startDate) {
    errors.startDate = "Start date is required";
  }

  if (!endDate) {
    errors.endDate = "End date is required";
  }

  if (endDate && startDate && endDate < startDate) {
    errors.endDate = "End date cannot be before start date";
  }


  return errors;
};

export const validateExpenseForm = (itemName = "", purchasedFrom = '',
  purchaseDate = null, selectedDepartment = '', amountSpent = '') => {
  let errors = {};
  if (!itemName.trim()) {
    errors.itemName = " Item name is required";
  }
  else if (!/^[A-Za-z\s]+$/.test(itemName)) {
    errors.itemName = " Item name must contain only letters";
  }
  else if (itemName.length < 2) {
    errors.itemName = " Item name must be at least 2 characters";
  } else if (itemName.length > 30) {
    errors.itemName = " Item name must not exceed 30 characters";
  }

  if (!purchaseDate) {
    errors.purchaseDate = "Purchase  date is required";
  }
  if (!purchasedFrom.trim()) {
    errors.purchasedFrom = " Purchase from is required";
  }
  else if (!/^[A-Za-z\s]+$/.test(purchasedFrom)) {
    errors.purchasedFrom = " Purchase from must contain only letters";
  }
  else if (purchasedFrom.length < 2) {
    errors.purchasedFrom = " Purchase from must be at least 2 characters";
  } else if (purchasedFrom.length > 30) {
    errors.purchasedFrom = " Purchase from must not exceed 30 characters";
  }
  if (!selectedDepartment.trim()) {
    errors.selectedDepartment = " Department is required";
  }
  if (!amountSpent.trim()) {
    errors.amountSpent = " Amount spent is required";
  }


  return errors;
};

export const validateAnnouncementForm = (title = "", description = '', selectedDepartment = '') => {
  let errors = {};
  if (!title.trim()) {
    errors.title = " Title is required";
  }
  else if (!/^[A-Za-z\s]+$/.test(title)) {
    errors.title = " Title must contain only letters";
  }
  else if (title.length < 2) {
    errors.title = " Title must be at least 2 characters";
  } else if (title.length > 30) {
    errors.title = " Title must not exceed 30 characters";
  }


  if (!description.trim()) {
    errors.description = "Description is required";
  }
  else if (!/^[A-Za-z\s]+$/.test(description)) {
    errors.description = "Description must contain only letters";
  }
  else if (description.length < 2) {
    errors.description = "Description must be at least 2 characters";
  } else if (description.length > 300) {
    errors.description = "Description must not exceed 300 characters";
  }
  if (!selectedDepartment.trim()) {
    errors.selectedDepartment = " Department is required";
  }
  // if (!amountSpent.trim()) {
  //   errors.amountSpent = " Amount spent is required";
  // }


  return errors;
};

export const validateExpenseReportForm = (selectedDate = null) => {
  let errors = {};
  if (!selectedDate) {
    errors.selectedDate = "Date is required.";
  }
  return errors;
};




